import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getNextOffset, getPrevOffset } from '@wix/da-shared-react/pkg/Stream/withOffset/selectors';
import { hasMore as getHasMore, getHasLess } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import noop from '@wix/da-shared-react/pkg/utils/noop';
import {
  fetchTableFirstPage,
  fetchTableLastPage,
  fetchTableNext,
  fetchTablePrevious,
} from '../../actions/studio';
import {
  getPageSize,
  getResultsTotalCount,
  getIsSearchPage,
  getTableStreamId,
} from '../../selectors/studio';
import { AppState } from '../../types/store';
import { Props } from './StudioPagination';

export type StateProps = Pick<
  Props,
  | 'streamId'
  | 'resultsTotalCount'
  | 'fromOffset'
  | 'toOffset'
  | 'hasMore'
  | 'hasLess'
  | 'isSearchPage'
>;
export type DispatchProps = Pick<
  Props,
  'fetchNext' | 'fetchPrevious' | 'fetchFirstPage' | 'fetchLastPage'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => {
  const streamId = getTableStreamId(state);
  const pageSize = getPageSize(state);
  const hasLess = getHasLess(state, streamId);
  const hasMore = getHasMore(state, streamId);
  const resultsTotalCount = getResultsTotalCount(state);
  const nextOffset = getNextOffset(state, streamId);
  const prevOffset = getPrevOffset(state, streamId);
  const toOffset = hasMore ? nextOffset : resultsTotalCount;
  const fromOffset = hasLess ? prevOffset + pageSize + 1 : 1;

  return {
    streamId,
    hasLess,
    hasMore,
    resultsTotalCount,
    toOffset,
    fromOffset,
    isSearchPage: getIsSearchPage(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { onFetchSuccess = noop }
) => {
  return {
    fetchNext: streamId => dispatch(fetchTableNext(streamId, onFetchSuccess)),
    fetchPrevious: streamId => dispatch(fetchTablePrevious(streamId, onFetchSuccess)),
    fetchFirstPage: streamId => dispatch(fetchTableFirstPage(streamId, onFetchSuccess)),
    fetchLastPage: streamId => dispatch(fetchTableLastPage(streamId, onFetchSuccess)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps);
